export default __webpack_public_path__ + "static/media/kabnoury ventueres (1).2d2dff26.svg";